import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { endpoints } from '../configuration.service';
import { environment } from 'src/environments/environment';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class MiddlewareService {
  private urlPortalSB: string;
  private urlPortalCms: string;


  // Definir variable de apiUrl....
  public apiUrl: string;

  constructor(
    private http: HttpClient,
    @Inject(DOCUMENT) private _doc: Document
  ) {
    this.urlPortalSB = environment.portalSb;
    this.urlPortalCms = environment.portalCms;

    if (environment.portalSb == 'https://www.segurosbanorte.com') {
      this.urlPortalSB = this._doc.defaultView.location.protocol + '//' + this._doc.defaultView.location.hostname;
    }
    if (environment.portalCms == 'https://www.segurosbanorte.com') {
      this.urlPortalCms = this._doc.defaultView.location.protocol + '//' + this._doc.defaultView.location.hostname;
    }
  }

  getUrlPortalSb() {
    return this.urlPortalSB;
  }

  getUrlPortalCms() {
    return this.urlPortalCms;
  }
  get(key, apiUri?: string) {
    let url: string;
    let apiPath = apiUri || this.apiUrl;
    url = (apiUri || this.apiUrl) + endpoints[key];
    if (apiPath == 'https://www.segurosbanorte.com') {
      url = this._doc.defaultView.location.protocol + '//' + this._doc.defaultView.location.hostname + endpoints[key];
    }

    return this.http.get(url);
  }

}
